import { z } from 'zod';
export const addressSchema = z
    .object({
    country: z.string().optional(),
    state: z.string().optional(),
    street: z.string().optional(),
    unit: z.string().optional(),
    city: z.string().optional(),
    postalcode: z.string().optional(),
})
    .meta({ field: 'address' });
